// Validation helpers for forms

const COMMON_TYPO_DOMAINS = {
    "gnail.com": "gmail.com",
    "gmial.com": "gmail.com",
    "gmail.co": "gmail.com",
    "gmail.cm": "gmail.com",
    "gmai.com": "gmail.com",
    "yahooo.com": "yahoo.com",
    "yaho.com": "yahoo.com",
    "yahoo.co": "yahoo.com",
    "hotmial.com": "hotmail.com",
    "hotmaill.com": "hotmail.com",
    "hotmail.co": "hotmail.com",
    "outlok.com": "outlook.com",
};

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

export function checkEmail(value) {
    if (!value) return { ok: false, error: "Email is required" };
    const v = value.trim().toLowerCase();
    if (!EMAIL_RE.test(v)) return { ok: false, error: "Enter a valid email (e.g. you@example.com)" };
    const domain = v.split("@")[1];
    const suggestion = COMMON_TYPO_DOMAINS[domain];
    if (suggestion) {
        const localPart = v.split("@")[0];
        return { ok: true, suggestion: `${localPart}@${suggestion}` };
    }
    return { ok: true };
}

/** Strip any non-digit. Return cleaned 10-digit string (max). */
export function cleanPhoneDigits(value) {
    return (value || "").replace(/\D+/g, "").slice(-10);
}

/** Validate 10-digit Indian phone (starts with 6-9). */
export function checkPhone(tenDigit) {
    const v = (tenDigit || "").trim();
    if (!v) return { ok: false, error: "Phone number is required" };
    if (v.length !== 10) return { ok: false, error: "Phone must be exactly 10 digits" };
    if (!/^[6-9]\d{9}$/.test(v)) return { ok: false, error: "Phone must start with 6, 7, 8 or 9" };
    return { ok: true };
}

export function fullPhone(tenDigit) {
    return tenDigit ? `+91${tenDigit}` : "";
}

/** Pull last 10 digits from a stored +91XXXXXXXXXX value (for prefilling forms). */
export function unwrapPhone(plus91) {
    return cleanPhoneDigits(plus91);
}
